import 'sharer.js'

import { Italian } from 'multiple-select-vanilla/dist/locales/multiple-select-it-IT';
import { English } from 'multiple-select-vanilla/dist/locales/multiple-select-en-US';
import { German } from 'multiple-select-vanilla/dist/locales/multiple-select-de-DE';
import { French } from 'multiple-select-vanilla/dist/locales/multiple-select-fr-FR';
import { multipleSelect } from 'multiple-select-vanilla';

import '../vendors/classie.min';
import '../vendors/selectFx';
import '../vendors/matchHeight';

export const initMultipleSelect = (target) => {
  const localeMap = {
    it: Italian,
    en: English,
    de: German,
    fr: French,
  };

  target.querySelectorAll('.multiple-select').forEach((el) => {
    multipleSelect(el, {
      selectAll: false,
      locale: localeMap[document.documentElement.lang || 'en'],
      filter: el.dataset.filter || false,
      showClear: el.dataset.showClear || false
    });
  });
};

export class GlobalModulesHandler {
  init () {
    this.initMultipleSelect();
    this.initSelectFx();
    this.inView();
    this.initScrollTopBtn();
    this.initMatchHeight();
    this.svgTransform();
  }

  initMultipleSelect () {
    initMultipleSelect(document);
  }

  initSelectFx () {
    document.querySelectorAll('.cs-select').forEach(select => {
      select.SelectFx = new SelectFx(select, {
        stickyPlaceholder: false,
        onChange: () => {
          select.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  inView () {
    const targets = document.querySelectorAll('[data-view]');

    const loadVideos = (sources) => {
      sources.forEach((source) => {
        if (!source.attributes.src.value && source.dataset.lazy) {
          source.src = source.dataset.lazy;
          source.closest('video').load();
        }
      });
    };

    const animateCounters = (counters) => {
      counters.forEach(counter => {
        if (counter.classList.contains('counter-finished')) {
          return;
        }

        const targetValue = Number(counter.innerText);
        const animationTime = 750;
        const interval = animationTime / targetValue;

        counter.innerText = 0;

        const animate = () => {
          const data = Number(counter.innerText);

          const speed = Number(counter.dataset.counterSpeed) || 200;
          const time = targetValue / speed;

          if (data < targetValue) {
            counter.innerText = Math.ceil(data + time);
            setTimeout(animate, interval);
          } else {
            counter.innerText = targetValue;
            counter.classList.add('counter-finished');
          }
        }

        const delay = Number(counter.closest('[data-view]').dataset.view);

        setTimeout(animate, (delay * 100) + 1000);
      });
    }

    const animationObserver = new IntersectionObserver(entries => {
      entries.map(entry => {
        const counters = entry.target.querySelectorAll('[data-counter-animate]');
        const lazyVideos = entry.target.querySelectorAll('[data-lazy]');

        if (entry.isIntersecting) {
          entry.target.classList.add('seen');

          if (counters.length) {
            animateCounters(counters)
          }
          if (lazyVideos.length) {
            loadVideos(lazyVideos)
          }
        }

        entry.target.classList.toggle('in-view', entry.isIntersecting);
      });
    });

    targets.forEach(target => animationObserver.observe(target));
  }

  initScrollTopBtn() {
    const target = document.querySelector('.scroll-top-btn');

    if (target && !CMS.editMode) {
      target.addEventListener('click', () => window.scrollTo({ top: 0 }));

      window.addEventListener('scroll', () => {
        const isHidden = window.scrollY < window.innerHeight / 3;

        target.classList.toggle('hide', isHidden);
      });
    }
  }

  initMatchHeight() {
    new MatchHeight();
  }

  svgTransform() {
    const images = document.querySelectorAll('img.replace-with-svg');

    images.forEach(img => {
      const imgURL = img.getAttribute('src');

      fetch(imgURL)
        .then((response) => response.text())
        .then((svgText) => {
            const parser = new DOMParser();
            const svgDocument = parser.parseFromString(svgText, 'image/svg+xml');
            const svgElement = svgDocument.querySelector('svg');

            if (svgElement) {
                for (const attr of img.attributes) {
                    if (attr.name !== 'src' && attr.name !== 'class') {
                        svgElement.setAttribute(attr.name, attr.value);
                    }
                }

                const imgClasses = img.getAttribute('class');

                if (imgClasses) {
                    svgElement.setAttribute('class', imgClasses.replace('replace-with-svg', 'replaced-svg').trim());
                }

                img.parentNode.replaceChild(svgElement, img);
            }
        })
        .catch((error) => {
            console.error(`Failed to fetch ${imgURL}:`, error);
        });
    })
  }
}
